import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        iconWrapper: {
            display: 'flex',
            alignItems: 'flex-start',
        },
        icon: {
            pointerEvents: 'all',
        },
        title: {
            color: `${theme.palette.common.white} !important`,
            fontSize: '16px !important',
        },
        spanWrapper: {
            display: 'block',
        },
        bodyText: {
            fontWeight: 300,
        },
        details: {
            color: theme.palette.error.main,
            padding: theme.spacing(0.5),
            marginTop: theme.spacing(0.5),
        },
        message: {
            overflow: 'auto',
            pointerEvents: 'auto',
            maxHeight: 200,
        },
        root: {
            marginTop: theme.spacing(0.5),
        },
    }
})

export default useStyles
